module.exports = __webpack_public_path__ + "static/media/PoorCrossIcon_01.13fdacb8.svg";